<template>
<div class="warp-info-sipenaru text-left bg-slate-50 py-5 px-4 md:px-[15vw]">
  <TitleSection title="Informasi SIPENMARU" />

  <div class="container my-5">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
      
      <!-- Kolom Kiri -->
      <div class="md:col-span-5 space-y-4">
        <div class="justify-center text-emerald-700 text-xl font-medium">
          {{ infoSipenmaru.title }}
        </div>
        <div class="text-sm text-slate-600 md:py-5 leading-relaxed">
          {{ infoSipenmaru.description }}
        </div>
        <a :href="infoSipenmaru.link.href" class="inline-flex items-center gap-2 bg-yellow-400 hover:bg-yellow-500 font-bold text-slate-800 px-4 py-2 rounded-md transition-all">
          {{ infoSipenmaru.link.text }}
          <i class="fas fa-arrow-right"></i>
        </a>
      </div>

      <!-- Kolom Kanan -->
      <div class="md:col-span-7 grid grid-cols-2 gap-4">
        <img v-for="(image, index) in infoSipenmaru.images" :key="index" :src="image.src" :alt="image.alt" class="rounded-none shadow-none" />
      </div>
    </div>
  </div>
</div>
</template>

<script setup>
import TitleSection from '@/components/TitleSection.vue';

const infoSipenmaru = {
  title: 'Tentang SIPENMARU (Seleksi Penerimaan Mahasiswa Baru).',
  description: 'SIPENMARU adalah proses seleksi masuk mahasiswa baru STIKES Sumber Waras untuk semua program studi yang tersedia. Proses ini terbuka untuk lulusan SMA/SMK sederajat dan dilakukan secara online maupun offline.',
  link: {
    text: 'Lihat Selengkapnya',
    href: '#'
  },
  images: [
    { src: require('@/assets/brosur1.png'), alt: 'Brosur 1' },
    { src: require('@/assets/brosur2.png'), alt: 'Brosur 2' }
  ]
};
</script>
